import {
  Button,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
} from "reactstrap";
import React, { useEffect, useState } from "react";
import SortableList from "../../Common/Components/Lists/SortableList";
import { useTranslation } from "react-i18next";
import ResponseInvoice from "../Models/Response/ResponseInvoice";
import useApiCallService from "../../Common/Helpers/ApiCall";
import { CustomReload } from "../../AppSystem/Helpers/CustomReload";
import { CustomModal } from "../../Common/Components/Modal/CustomModal";
import $ from "jquery";
import { ADMIN_PATHS, API_URL, ORGANIZATION_PATHS } from "../../config";
import { useNavigate } from "react-router-dom";
import { FlashMessage } from "../../Common/Helpers/FlashMessage";
import { CheckUserPermission } from "../../AppSystem/Helpers/CheckUserPermission";
import { CheckUserRole } from "../../AppSystem/Helpers/CheckUserRole";
import { CustomInput } from "../../Common/Components/Input/CustomInput";
import { FlashMessageInsufficientAccountAmount } from "../../Common/Helpers/FlashMessageInsufficientAccountAmount";
import { useSelector } from "react-redux";
import AdminRequestAttestApprovedModel from "../../Attest/Model/Request/AdminRequestAttestApprovedModel";
import AdminRequestAttestDenyModel from "../../Attest/Model/Request/AdminRequestAttestDenyModel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {CustomButton} from "../../Common/Components/Button/CustomButton";
import { useHeader } from "../../Auth/Components/Nav/HeaderContext";
import { createPortal } from "react-dom";

export function AdminInvoiceList() {
    const { t } = useTranslation();
    const { ApiCall } = useApiCallService();
    const { rolesData, userData } = useSelector(state => state.auth);
    const { setPageTitle, setPageTitleKey, setOnBack } = useHeader();

    useEffect(() => {
        setPageTitle(t('invoice.invoice'));
        setPageTitleKey('invoice.invoice');
        setOnBack(null);
        return () => { setPageTitle(''); setPageTitleKey(''); setOnBack(null); };
    }, [t]);

  const [dropdownOpen, setDropdownOpen] = useState({});
  const [displayDeleteModal, setDisplayDeleteModal] = useState(false);
  const [idRow, serIdRow] = useState("");
  const navigate = useNavigate();
  const [flagTest, setFlagTest] = useState(false);

    // VAT MANAGEMENT MODAL
    const isAdmin = CheckUserRole(rolesData, 'Admin');

  // PAYMENT DATE STATE
  const [paymentDate, setPaymentDate] = useState("");
  const [paymentDateError, setPaymentDateError] = useState(false);
  const [showPaymentDateInput, setShowPaymentDateInput] = useState(false);

  // ATTEST STATES
  const [apiRequestAcceptAttest, setApiRequestAcceptAttest] = useState(
    new AdminRequestAttestApprovedModel(),
  );
  const [apiRequestDenyAttest, setApiRequestDenyAttest] = useState(
    new AdminRequestAttestDenyModel(),
  );
  const [apiResponseAttest, setApiResponseAttest] = useState(null);
  const [typeAttest, setTypeAttest] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showConfirmModalApprove, setShowConfirmModalApprove] = useState(false);
  const [showConfirmModalWariningApprove, setShowConfirmModalWarningApprove] =
    useState(false);
  const [showConfirmModalWariningDeny, setShowConfirmModalWarningDeny] =
    useState(false);
  const [showConfirmModalDeny, setShowConfirmModalDeny] = useState(false);
  const [errorReason, setErrorReason] = useState(false);
  const [attestList, setAttestList] = useState({});

  const renderDatePickerInPortal = ({ children }) => {
    return createPortal(children, document.body);
  };

  // USER PERMISSIONS
  let approvePermission = false;
  if (
    CheckUserPermission("admin.invoice.approve") ||
    CheckUserPermission("admin.invoice") ||
    CheckUserPermission("admin")
  ) {
    approvePermission = true;
  }

  let denyPermission = false;
  if (
    CheckUserPermission("admin.invoice.deny") ||
    CheckUserPermission("admin.invoice") ||
    CheckUserPermission("admin")
  ) {
    denyPermission = true;
  }

  let payPermission = false;
  if (
    CheckUserPermission("admin.invoice.pay") ||
    CheckUserPermission("admin.invoice") ||
    CheckUserPermission("admin")
  ) {
    payPermission = true;
  }

  let creditPermission = false;
  if (
    CheckUserPermission("admin.invoice.credit") ||
    CheckUserPermission("admin.invoice") ||
    CheckUserPermission("admin")
  ) {
    creditPermission = true;
  }

  let viewPermission = false;
  if (
    CheckUserPermission("admin.invoice.view") ||
    CheckUserPermission("admin.invoice") ||
    CheckUserPermission("admin")
  ) {
    viewPermission = true;
  }

  let manageVatPermission = false;
  if (
    CheckUserPermission("admin.invoice.manageVat") ||
    CheckUserPermission("admin.invoice") ||
    CheckUserPermission("admin")
  ) {
    manageVatPermission = true;
  }

  const completeSchemaAccept = AdminRequestAttestApprovedModel.getAttributes(
    null,
    true,
  );
  const completeSchemaDeny = AdminRequestAttestDenyModel.getAttributes(
    null,
    true,
  );

  let userRole = false;
  if (CheckUserRole(rolesData, "Support")) {
    userRole = true;
  }

  // GET ATTEST DATA FOR INVOICES
  useEffect(() => {
    const handleAttestResponse = (response) => {
      if (response && Array.isArray(response)) {
        const attestMap = {};
        response.forEach((attest) => {
          if (attest.modelVisualId) {
            attestMap[attest.modelVisualId] = attest;
          }
        });
        setAttestList(attestMap);
      }
    };

    const GetAttestList = async () => {
      try {
        const apiCallOptions = {
          method: "get",
          url: "/attest/admin/search-pending-for-invoice",
        };
        await ApiCall(apiCallOptions, handleAttestResponse);
      } catch (error) {
        console.log("error", error);
      }
    };

    GetAttestList();
  }, []);

  // HANDLE ATTEST APPROVE
  const handleChangeAttestApprove = (attestItem) => {
    setApiRequestAcceptAttest((prevFormData) => ({
      ...prevFormData,
      id: attestItem.id,
      attested: true,
    }));
  };

  // HANDLE ATTEST DENY
  const handleChangeAttestDenyId = (id) => {
    setApiRequestDenyAttest((prevFormData) => ({
      ...prevFormData,
      id: id,
    }));
  };

  // HANDLE ATTEST DENY REASON
  const handleChangeAttestDenyReason = (e) => {
    if (e && e.target && e.target.value && e.target.value !== "") {
      setApiRequestDenyAttest((prevFormData) => ({
        ...prevFormData,
        reason: e.target.value,
      }));
      setErrorReason(false);
    } else {
      setErrorReason(true);
    }
  };

  // ATTEST VALIDATION
  const handleAttestValidation = async (type) => {
    try {
      if (type === "approve") {
        await completeSchemaAccept.validate(apiRequestAcceptAttest, {
          abortEarly: false,
        });
      } else {
        await completeSchemaDeny.validate(apiRequestDenyAttest, {
          abortEarly: false,
        });
      }
      const apiCallOptions = {
        method: type === "approve" ? "put" : "delete",
        url: "/attest/admin/invoice",
        data:
          type === "approve" ? apiRequestAcceptAttest : apiRequestDenyAttest,
      };
      setTypeAttest(type);
      try {
        await ApiCall(apiCallOptions, setApiResponseAttest, setErrorMessage);
      } catch (error) {
        console.log(error);
        FlashMessage(t("validationMessage.sendError"), "flash-messageError");
        enableAttestButtons();
      }
    } catch (err) {
      setErrorReason(true);
      console.log(err);
    }
  };

  const disableAttestButtons = () => {
    const allButtons = document.querySelectorAll("button");
    allButtons.forEach((button) => {
      if (button.classList.contains("class-approve-attest")) {
        button.disabled = true;
        button.classList.remove("bg-green-light", "text-green");
        button.classList.add("bg-grey-tab");
      } else if (button.classList.contains("class-deny-attest")) {
        button.disabled = true;
        button.classList.remove("box-red", "text-red");
        button.classList.add("bg-grey-tab");
      }
    });
  };

    const enableAttestButtons = () => {
        const allButtons = document.querySelectorAll('button');
        allButtons.forEach(button => {
            if (button.classList.contains('class-approve-attest')) {
                button.disabled = false;
                button.classList.add('bg-green-light', 'text-green');
                button.classList.remove('bg-grey-tab');
            } else if (button.classList.contains('class-deny-attest')) {
                button.disabled = false;
                button.classList.add('box-red', 'text-red');
                button.classList.remove('bg-grey-tab');
            }
        });
    }

  const handleApiResponse = (apiResponse) => {
    if (apiResponse !== null && apiResponse !== undefined) {
      CustomReload();
    } else {
      FlashMessage(
        "Användaren tillhör inte organisationen",
        "flash-messageError",
      );
      setDisplayDeleteModal(false);
    }
  };

  const ChangeStatus = async (id, paymentDate) => {
    if (id !== "") {
      const paymentDateTime = `${paymentDate}T12:00:00`;

      let json = {
        id: id,
        status: "Betalad",
        paymentDate: paymentDateTime,
      };

      const apiCallOptions = {
        method: "put",
        url: "/invoice/admin",
        data: json,
      };
      try {
        await ApiCall(apiCallOptions, handleApiResponse);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleOptionSelect = async (id) => {
    // Validate payment date before proceeding
    if (!paymentDate) {
      setPaymentDateError(true);
      return;
    }

    $("#acceptButton").prop("disabled", true);
    await ChangeStatus(id, paymentDate);
  };

  const toggle = (id) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const defaultExportFormatOptions = ["Betalad", "Krediteras", "Återkallad"];
  const options = defaultExportFormatOptions;

  const renderActionColumn = (item) => {
    const attestItem = attestList[item.visualId];
    const hasAttest = attestItem && attestItem.status === "Skickat";
    const isAttestOwner = attestItem && attestItem.createdBy === userData?.id;

    return (
      <>
        {/* ATTEST APPROVE BUTTON */}
        {hasAttest && !isAttestOwner && approvePermission ? (
          <button
            id={`attest-approve-${attestItem.id}`}
            className="rounded me-2 py-2 border-0 text-green bg-green-light p-custom-button position-relative class-approve-attest"
            onClick={() => {
              handleChangeAttestApprove(attestItem);
              if (attestItem.orgType === "Lokal grupp" && userRole) {
                setShowConfirmModalWarningApprove(true);
              } else {
                setShowConfirmModalApprove(true);
              }
              disableAttestButtons();
            }}
          >
            <i className="bx bx-list-check pb-custom align-middle size-icon-custom-button" />
            <div className="tooltip-custom-button">{t("attest.approve")}</div>
          </button>
        ) : (
          ""
        )}

        {/* ATTEST DENY BUTTON */}
        {hasAttest && !isAttestOwner && denyPermission ? (
          <button
            id={`attest-deny-${attestItem.id}`}
            className="rounded me-2 py-2 border-0 text-red box-red p-custom-button position-relative class-deny-attest"
            onClick={() => {
              handleChangeAttestDenyId(attestItem.id);
              if (attestItem.orgType === "Lokal grupp" && userRole) {
                setShowConfirmModalWarningDeny(true);
              } else {
                setShowConfirmModalDeny(true);
              }
              disableAttestButtons();
            }}
          >
            <i className="bx bx-list-minus pb-custom align-middle size-icon-custom-button" />
            <div className="tooltip-custom-button">{t("attest.deny")}</div>
          </button>
        ) : (
          ""
        )}

        {/* CREDIT INVOICE BUTTON */}
        {creditPermission === true &&
        ["Godkänd", "Betalad", "Återkallad"].includes(item.status) &&
        item.type === "Faktura" &&
        !item.creditInvoiceReferenceId ? (
          <Button
            className="box-orange border-0 position-relative me-2 rounded class-yellow-button"
            onClick={() => {
              navigate(`${ADMIN_PATHS.ADMIN_INVOICE_CREDIT}?id=${item.id}`);
            }}
          >
            <i className="bx bxs-file-import align-middle pb-1 fs-5" />
            <div className="tooltip-custom-button">
              {t("invoice.creditInvoice")}
            </div>
          </Button>
        ) : (
          ""
        )}

        {/* PAY INVOICE BUTTON (NOT FOR CREDIT INVOICES NOR FOR INVOICES WITH A CREDIT INVOICE WAITING FOR APPROVAL) */}
        {payPermission === true && item.status === "Godkänd" && item.totalAmount >= 0 && !item.creditInvoiceReferenceId ? (
          <Button
            id="btnPayInvoice"
            className="bg-green-light text-green border-0 position-relative me-2 rounded class-green-button"
            onClick={() => {
              serIdRow(item.id);
              const today = new Date();
              const year = today.getFullYear();
              const month = String(today.getMonth() + 1).padStart(2, "0");
              const day = String(today.getDate()).padStart(2, "0");
              setPaymentDate(`${year}-${month}-${day}`);
              setPaymentDateError(false);
              setShowPaymentDateInput(false);
              setDisplayDeleteModal(true);
              const elements = document.querySelectorAll(
                "button.class-green-button, a.class-green-button, button.box-orange",
              );
              elements.forEach((element) => {
                if (element.classList.contains("class-green-button")) {
                  setFlagTest(true);
                  element.disabled = true;
                  element.classList.remove("bg-green-light", "text-green");
                  element.classList.add("bg-grey-tab", "text-secondary");
                } else if (element.classList.contains("class-yellow-button")) {
                  element.disabled = true;
                  element.classList.remove("box-orange");
                  element.classList.add("bg-grey-tab", "text-secondary");
                }
              });
            }}
          >
            <i className="bx bx-check fs-5 align-middle pb-1" />
            <div className="tooltip-custom-button">{t("invoice.paid")}</div>
          </Button>
        ) : (
          ""
        )}

        {/* PDF BUTTON */}
        {item.fileUrl ? (
          flagTest === true ? (
            <a
              href="#"
              className="btn bg-green-light text-green border-0 rounded position-relative class-green-button"
            >
              <i className="bx bxs-file-pdf fs-5 align-middle pb-1" />
            </a>
          ) : (
            <a
              href={API_URL + item.fileUrl}
              className="btn bg-green-light text-green border-0 rounded position-relative class-green-button"
            >
              <i className="bx bxs-file-pdf fs-5 align-middle pb-1" />
            </a>
          )
        ) : (
          ""
        )}
      </>
    );
  };

  // ATTEST MODAL CONTENTS
  const contentBodyApproved = <div>{t("validationMessage.modalAttest")}</div>;

  const contentFooterApproved = (
    <>
      <Button
        className="box-green border-0"
        onClick={async () => {
          setShowConfirmModalApprove(false);
          await handleAttestValidation("approve");
        }}
      >
        {t("button.accept")}
      </Button>
      <Button
        className="box-red border-0"
        onClick={() => {
          setShowConfirmModalApprove(false);
          enableAttestButtons();
        }}
      >
        {t("button.cancel")}
      </Button>
    </>
  );


  const contentHeaderWarningApproved = (
    <h2 className="rokkitt-font avatar-title">
      {t("attest.warningTitleLokalGroup")}
    </h2>
  );

  const contentBodyWarningApproved = (
    <>
      <div style={{ marginBottom: "1rem" }}>
        {t("attest.warningLokalGroup")}
      </div>
      <div>{t("attest.warningLokalGroupSubText")}</div>
    </>
  );

  const contentFooterWarningApproved = (
    <>
      <Button
        className="box-green border-0"
        onClick={async () => {
          setShowConfirmModalWarningApprove(false);
          await handleAttestValidation("approve");
        }}
      >
        {t("button.accept")}
      </Button>
      <Button
        className="box-red border-0"
        onClick={() => {
          setShowConfirmModalWarningApprove(false);
          enableAttestButtons();
        }}
      >
        {t("button.cancel")}
      </Button>
    </>
  );

const contentHeaderWarningDeny = (
  <h2 className="rokkitt-font avatar-title">
    {t("attest.warningTitleLokalGroup")}
  </h2>
);

  const contentBodyWarningDeny = (
    <>
      <div style={{ marginBottom: "1rem" }}>
        {t("attest.warningLokalGroup")}
      </div>
      <div className="d-flex justify-content-center">
        <div className="w-75 position-relative">
          <CustomInput
            model={AdminRequestAttestDenyModel}
            attribute="reason"
            customChange={(e) => handleChangeAttestDenyReason(e)}
          />
          <div
            className={`error tooltip-custom-normal ${errorReason === true ? "opacity-1" : "opacity-0"}`}
            style={{ color: "#f56e6e" }}
          >
            {t("validationMessage.fieldRequired")}
          </div>
        </div>
      </div>
      <div>{t("attest.warningLokalGroupSubText")}</div>
    </>
  );

  const contentHeaderDeny = (
    <div className="text-center pb-3">
        <h5 className="rokkitt-font">
          {t("validationMessage.modalAttestDenyHeader")}
        </h5>
      </div>
  );

  const contentBodyDeny = (
    <>
      <div className="d-flex justify-content-center">
        <div className="w-75 position-relative">
          <CustomInput
            model={AdminRequestAttestDenyModel}
            attribute="reason"
            customChange={(e) => handleChangeAttestDenyReason(e)}
          />
          <div
            className={`error tooltip-custom-normal ${errorReason === true ? "opacity-1" : "opacity-0"}`}
            style={{ color: "#f56e6e" }}
          >
            {t("validationMessage.fieldRequired")}
          </div>
        </div>
      </div>
      <div>{t("validationMessage.modalAttestDeny")}</div>
    </>
  );

  const contentFooterDeny = (
    <>
      <Button
        className="box-green border-0"
        onClick={async () => {
          setShowConfirmModalDeny(false);
          await handleAttestValidation("deny");
        }}
      >
        {t("button.accept")}
      </Button>
      <Button
        className="box-red border-0"
        onClick={() => {
          setShowConfirmModalDeny(false);
          setErrorReason(false);
          enableAttestButtons();
        }}
      >
        {t("button.cancel")}
      </Button>
    </>
  );

  const contentFooterWarningDeny = (
    <>
      <Button
        className="box-green border-0"
        onClick={async () => {
          setShowConfirmModalWarningDeny(false);
          await handleAttestValidation("deny");
        }}
      >
        {t("button.accept")}
      </Button>
      <Button
        className="box-red border-0"
        onClick={() => {
          setShowConfirmModalWarningDeny(false);
          setErrorReason(false);
          enableAttestButtons();
        }}
      >
        {t("button.cancel")}
      </Button>
    </>
  );

  // INVOICE PAYMENT MODAL
  const modalHeader = (
    <div className="mb-3">{t("validationMessage.changeStatus")}</div>
  );

  const modalContent = (
    <div>
      <div className="d-flex justify-content-center mb-3">
        <div className="w-50 position-relative">
          <label className="form-label fw-bold">
            {t("invoice.paymentDate")}
          </label>
          <DatePicker
            className={`form-control w-100 ${paymentDateError ? "is-invalid" : ""}`}
            selected={
              paymentDate ? new Date(paymentDate + "T00:00:00") : new Date()
            }
            onChange={(date) => {
              if (date) {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const day = String(date.getDate()).padStart(2, "0");
                const formattedDate = `${year}-${month}-${day}`;
                setPaymentDate(formattedDate);
                setPaymentDateError(false);
              } else {
                setPaymentDate("");
                setPaymentDateError(true);
              }
            }}
            maxDate={new Date()}
            dateFormat="yyyy-MM-dd"
            placeholderText={t("invoice.selectPaymentDate")}
            wrapperClassName="w-100"
            showPopperArrow={false}
            popperClassName="invoice-payment-datepicker-popper"
            popperContainer={renderDatePickerInPortal}
          />
          <div
            className={`error tooltip-custom-normal ${paymentDateError === true ? "opacity-1" : "opacity-0"}`}
            style={{ color: "#f56e6e" }}
          >
            {t("validationMessage.fieldRequired")}
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-center gap-2">
        <Button
          id="acceptButton"
          className="box-green border-0"
          onClick={() => handleOptionSelect(idRow)}
        >
          {t("button.accept")}
        </Button>
        <Button
          className="box-red border-0"
          onClick={() => {
            setDisplayDeleteModal(false);
            setPaymentDate("");
            setPaymentDateError(false);
            const elements = document.querySelectorAll(
              "button.class-green-button, a.class-green-button, button.class-yellow-button",
            );
            elements.forEach((element) => {
              if (element.classList.contains("class-green-button")) {
                setFlagTest(false);
                element.disabled = false;
                element.classList.add("bg-green-light", "text-green");
                element.classList.remove("bg-grey-tab", "text-secondary");
              } else if (element.classList.contains("class-yellow-button")) {
                element.disabled = false;
                element.classList.add("box-orange");
                element.classList.remove("bg-grey-tab", "text-secondary");
              }
            });
          }}
        >
          {t("button.cancel")}
        </Button>
      </div>
    </div>
  );

  const modalFooter = !showPaymentDateInput ? null : null;

  // HANDLE ATTEST RESPONSE
  useEffect(() => {
    if (apiResponseAttest !== null && typeAttest !== "") {
      try {
        if (typeof window !== "undefined" && window.localStorage) {
          Object.keys(window.localStorage).forEach((key) => {
            if (
              key.startsWith("adminAttest") ||
              key.startsWith("AdminInvoice")
            ) {
              window.localStorage.removeItem(key);
            }
          });
        }
      } catch (e) {
        console.warn("Error clearing localStorage keys", e);
      }

      if (typeAttest === "approve") {
        FlashMessage(
          t("validationMessage.attestApproved"),
          "flash-messageSuccess",
        );
        setShowConfirmModalApprove(false);
        setShowConfirmModalWarningApprove(false);
      } else {
        setShowConfirmModalDeny(false);
        setShowConfirmModalWarningDeny(false);
        FlashMessage(
          t("validationMessage.attestDenied"),
          "flash-messageSuccess",
        );
      }
      setTimeout(() => {
        CustomReload();
      }, 2000);
    }
  }, [apiResponseAttest]);

  // HANDLE ATTEST ERROR MESSAGES
  useEffect(() => {
    if (errorMessage !== "") {
      if (errorMessage.includes("{")) {
        FlashMessage(
          <FlashMessageInsufficientAccountAmount jsonString={errorMessage} />,
          "flash-messageError",
          null,
          true,
        );
      } else {
        if (errorMessage === "InsufficientBalance") {
          FlashMessage(
            t("validationMessage.insufficientBalance"),
            "flash-messageError",
          );
        } else if (errorMessage === "UserNeedBankAccount") {
          FlashMessage(t("validationMessage.notAccount"), "flash-messageError");
        } else if (errorMessage === "Conflict") {
          FlashMessage(
            t(
              "En annan användare har redan påbörjat attest av detta ärende. Kontrollera ärendets status.",
            ),
            "flash-messageError",
            5000,
          );
        } else if (errorMessage === "AttestNotFound") {
          FlashMessage(
            t(
              "En annan användare har redan påbörjat attest av detta ärende. Kontrollera ärendets status.",
            ),
            "flash-messageError",
            5000,
          );
        } else if (
          errorMessage ===
          "Det gick inte att generera ett unikt tillfälligt fakturanummer efter flera försök, försök igen."
        ) {
          FlashMessage(errorMessage, "flash-messageError");
        } else {
          FlashMessage(t("validationMessage.sendError"), "flash-messageError");
        }
      }
      setTimeout(() => {
        enableAttestButtons();
      }, 2000);
      setApiResponseAttest(null);
      if (errorMessage === "Conflict" || errorMessage === "AttestNotFound") {
        setErrorMessage("");
        setTimeout(() => {
          CustomReload();
        }, 5200);
      }
      setErrorMessage("");
    }
  }, [errorMessage]);

  const columns = [
    "visualId",
    "invoiceNumber",
    "clientName",
    "orgName",
    "sentAt",
    "expiringDate",
    "paymentDate",
    "status",
    "totalAmount",
  ];
  const listOptions = {
    model: ResponseInvoice,
    columns: columns,
    actions: {
      actionColumn: renderActionColumn,
    },
    exportIsAvailable: true,
    urlGetListItemsToExport: "/invoice/admin/search/filter",
    nameFile: t("invoice.invoice"),
    ignoreFields: columns,
    modelType: "AdminInvoice",
    filterTestIsAvailable: true,
    urlGetSearch: "/invoice/admin/search/filter",
    viewName: "AdminInvoiceList",
  };

  return (
    <Col lg={12}>
      {/* ATTEST MODALS */}
      <CustomModal
        isOpen={showConfirmModalApprove}
        toggle={() => setShowConfirmModalApprove(!showConfirmModalApprove)}
        header={contentHeaderWarningApproved}
        body={contentBodyApproved}
        footer={contentFooterApproved}
      />
      <CustomModal
        isOpen={showConfirmModalWariningApprove}
        toggle={() =>
          setShowConfirmModalWarningApprove(!showConfirmModalWariningApprove)
        }
        header={contentHeaderWarningApproved}
        body={contentBodyWarningApproved}
        footer={contentFooterWarningApproved}
      />
      <CustomModal
        isOpen={showConfirmModalWariningDeny}
        toggle={() =>
          setShowConfirmModalWarningDeny(!showConfirmModalWariningDeny)
        }
        header={contentHeaderWarningDeny}
        body={contentBodyWarningDeny}
        footer={contentFooterWarningDeny}
      />
      <CustomModal
        isOpen={showConfirmModalDeny}
        toggle={() => setShowConfirmModalDeny(!showConfirmModalDeny)}
        header={contentHeaderDeny}
        body={contentBodyDeny}
        footer={contentFooterDeny}
      />

      {/* INVOICE PAYMENT MODAL */}
      <CustomModal
        isOpen={displayDeleteModal}
        toggle={() => {
          setDisplayDeleteModal(!displayDeleteModal);
          setShowPaymentDateInput(false);
          setPaymentDate("");
          setPaymentDateError(false);
          if (displayDeleteModal) {
            const elements = document.querySelectorAll(
              "button.class-green-button, a.class-green-button, button.class-yellow-button",
            );
            elements.forEach((element) => {
              if (element.classList.contains("class-green-button")) {
                setFlagTest(false);
                element.disabled = false;
                element.classList.add("bg-green-light", "text-green");
                element.classList.remove("bg-grey-tab", "text-secondary");
              } else if (element.classList.contains("class-yellow-button")) {
                element.disabled = false;
                element.classList.add("box-orange");
                element.classList.remove("bg-grey-tab", "text-secondary");
              }
            });
          }
        }}
        header={modalHeader}
        body={modalContent}
        footer={modalFooter}
      />

      <Row className="pb-5">
        <Col lg={12} className="p-4 pb-3 mt-4 card-backend">
          <Row className="align-items-center mb-2">
            <Col>
              <h2 className="fw-bold rokkitt-font">
                {t("invoice.invoiceList")}
              </h2>
            </Col>
            {/* "Manage VAT" button hidden: VAT configurations are now the "Fakturakonton" tab of the economic settings view */}
            {/* {manageVatPermission && (
              <Col xs="auto" className="d-flex justify-content-end">
                <CustomButton
                  className="bg-green border-0"
                  icon={"bx bx-cog"}
                  text={t("invoice.manageVat")}
                  onClick={() => navigate(ADMIN_PATHS.ADMIN_INVOICE_ACCOUNTS)}
                />
              </Col>
            )} */}
          </Row>
          <SortableList listOptions={listOptions} />
        </Col>
      </Row>
    </Col>
  );
}
